module.exports = __webpack_public_path__ + "static/media/particles.f46fffb7.gif";